import React from 'react';

import PlainInput from '../plain';

const EmailInput = ({ ...props }) => <PlainInput {...props} placeholder="Email" /* autoComplete="email" */ type="email" />;

export default EmailInput;
